import React from "react";
import "../styles//AutoGasPromo.scss";

const packages = [
  {
    id: 1,
    cylinders: "4 cilindros",
    monthlyText: "6 pagos de",
    monthlyPrice: "$2,833",
    cashLabel: "Precio de contado",
    cashPrice: "$16,999",
    msiText: "o a 6MSI",
  },
  {
    id: 2,
    cylinders: "6 cilindros",
    monthlyText: "6 pagos de",
    monthlyPrice: "$3,333",
    cashLabel: "Precio de contado",
    cashPrice: "$19,999",
    msiText: "o a 6MSI",
  },
  {
    id: 3,
    cylinders: "8 cilindros",
    monthlyText: "6 pagos de",
    monthlyPrice: "$3,833",
    cashLabel: "Precio de contado",
    cashPrice: "$22,999",
    msiText: "o a 6MSI",
  },
];

const AutoGasPromo = ({
  phone = "998 214 6284",
  whatsappNumber = "529982146284",
  downPayment = "$4,000",
}) => {
  const whatsappMessage = encodeURIComponent(
    "Hola, quiero información sobre la conversión de mi auto a Gas LP."
  );

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <section className="autoGasPromo">
      <div className="autoGasPromo__wrap">
        <div className="autoGasPromo__top">
          <h2 className="autoGasPromo__headline">
            <span className="autoGasPromo__headlineWhite">
              🚗 Convierte tu auto a Gas LP
            </span>
            <span className="autoGasPromo__headlineYellow">
              y empieza a ahorrar
            </span>
            <span className="autoGasPromo__headlineWhite">
              desde el primer día
            </span>
          </h2>

          <div className="autoGasPromo__downPayment">
            Enganche desde <strong>{downPayment}</strong>
          </div>
        </div>

        <div className="autoGasPromo__pricing">
          {packages.map((item) => (
            <article className="autoGasPromo__priceCard" key={item.id}>
              <div className="autoGasPromo__priceLeft">
                <h3>{item.cylinders}</h3>
                <p>{item.monthlyText}</p>
                <span>{item.monthlyPrice}</span>
              </div>

              <div className="autoGasPromo__priceDivider" />

              <div className="autoGasPromo__priceCenter">
                <p>{item.cashLabel}</p>
                <span>{item.msiText}</span>
              </div>

              <div className="autoGasPromo__priceDivider" />

              <div className="autoGasPromo__priceRight">
                <strong>{item.cashPrice}</strong>
              </div>
            </article>
          ))}
        </div>

        <div className="autoGasPromo__benefits">
          <div className="autoGasPromo__benefit">
            <span>⭐</span>
            <p>Ahorra hasta un 50% en combustible</p>
          </div>

          <div className="autoGasPromo__benefit">
            <span>🔁</span>
            <p>Sistema dual: gasolina + gas</p>
          </div>

          <div className="autoGasPromo__benefitNote">
            Manejamos equipos para todos los tamaños. Pregunta por tu precio.
          </div>
        </div>

        <div className="autoGasPromo__bottom">
          <div className="autoGasPromo__ctaText">
            <span>Agenda hoy</span>
            <p>y deja de gastar de más</p>
          </div>

          <div className="autoGasPromo__ctaBox">
            <p className="autoGasPromo__phone">WhatsApp: {phone}</p>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="autoGasPromo__button"
            >
              Cotizar por WhatsApp →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutoGasPromo;